// ปุ่มเลือกภาษา (8 ภาษา) — วางที่หัวเว็บ
import React, { useEffect, useRef, useState } from 'react';
import { LANGS, getLang, setLang, subscribeLang } from './index';
import './langswitcher.css';

export default function LangSwitcher() {
  const [lang, setL] = useState(getLang());
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => subscribeLang(setL), []);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    document.addEventListener('touchstart', close);
    return () => { document.removeEventListener('mousedown', close); document.removeEventListener('touchstart', close); };
  }, []);

  const cur = LANGS.find((l) => l.code === lang) || LANGS[0];
  return (
    <div className="bt-lang" ref={ref} data-no-i18n="">
      <button type="button" className="bt-lang-btn" onClick={() => setOpen((o) => !o)} aria-haspopup="listbox" aria-expanded={open}>
        <img className="bt-lang-flag" src={cur.flag} alt="" />
        <span className="bt-lang-code">{cur.short}</span>
        <span className="bt-lang-caret">▾</span>
      </button>
      {open && (
        <ul className="bt-lang-menu" role="listbox">
          {LANGS.map((l) => (
            <li key={l.code}>
              <button type="button" role="option" aria-selected={l.code === lang}
                className={'bt-lang-item' + (l.code === lang ? ' active' : '')}
                onClick={() => { setLang(l.code); setOpen(false); }}>
                <img className="bt-lang-flag" src={l.flag} alt="" />
                <span>{l.label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
